import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { Info } from 'lucide-react';
import { cn } from '@antimatterhq/ui/lib/utils';
import Tooltip, {
  type TooltipProps,
} from '@antimatterhq/ui/components/tooltip';
const TooltipProvider = TooltipPrimitive.Provider;

export type InfoTooltipProps = {
  styles?: string;
  trigger?: React.ReactNode;
  interactive?: boolean;
  className?: string;
} & TooltipProps;

export const InfoTooltip = ({
  content,
  side,
  align,
  styles,
  trigger = (
    <Info
      color={'rgba(var(--grey-400), 1)'}
      className="cursor-pointer"
      size={12}
    />
  ),
}: InfoTooltipProps) => {
  return (
    <TooltipProvider>
      <div data-testid="info-tooltip" className={cn('flex', styles)}>
        <Tooltip
          content={content}
          side={side}
          align={align}
          delayDuration={200}
        >
          <span data-testid="info-tooltip-icon">{trigger}</span>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
};
